import { withStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'
import theme from '../../assets/theme'

const themePalette = theme().palette

export const CustomSlider = withStyles({
  root: {
    color: themePalette.text.sliderTrackColor,
    height: 8,
  },
  thumb: {
    height: 13,
    width: 13,
    backgroundColor: themePalette.text.sliderTrackColor,
    border: '2px solid currentColor',
    marginTop: -4,
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(Slider)
